export enum ProcessStatusEnum {
  Pending = "pending",
  Running = "running",
  Retrying = "retrying",
  Done = "done",
  Failed = "failed",
}

export interface ProcessResource {
  id: string;
  type: string;
  label: string;
  status: ProcessStatusEnum;
  step_key: string | null;
  step_label: string | null;
  step_current: number;
  step_total: number;
  current_percent: number;
  attempt: number;
  error: string | null;
  result: {
    type: string;
    [key: string]: unknown;
  } | null;
  started_at: string | null;
  finished_at: string | null;
}
